import axios from "axios";
import { URL_ENV } from "utils/const.ts";

export function getToken() {
  if (typeof window === "undefined") return "";
  const authUser = localStorage.getItem("azulfyAuthUser");
  let token = "";

  if (authUser) {
    try {
      const userAuth = JSON.parse(authUser);
      token = userAuth?.token;
    } catch (error) {
      console.log(error);
    }
  }
  return token;
}

export const api = axios.create({
  baseURL: URL_ENV,
});

api.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getToken()}`;
    config.headers.Accept = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data?.content?.error === 100) {
      if (typeof window !== "undefined") {
        const pathname = window.location.pathname;
        if (!pathname.includes("/password-expired")) {
          window.location.href = "/password-expired";
        }
      }
    }
    return Promise.reject(error);
  },
);
